import {Box,Table,Thead,Tbody,Tr,Th,Td,TableContainer, Badge, IconButton,Menu,MenuButton,MenuList, MenuItem, Avatar,Tooltip,Text, Center} from '@chakra-ui/react'
import {  EditIcon, HamburgerIcon, ViewIcon } from '@chakra-ui/icons';
import {ImStatsDots} from 'react-icons/im';
import {useState } from 'react'
import {  colorSchmemes } from '../../util/grunt';
import GruntPager from '../custom/GruntPager';

export default function DolasciTable({dolasci,onEditDolazak,onViewDolazak,onStat,tableSize='xs',readonly=false}) {
    
    const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",rowsperpage:20,currpage:1});
    

    const ShowGruntPager=()=>{
        if (dolasci.length>0) {
            return (
                <GruntPager currpage={prikaz.currpage} rowcount={dolasci.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                );    
        }
        
    }

    const migracijaEdit=(migracijaid,migracijatipsifra)=>{
        onEditDolazak(migracijaid,migracijatipsifra);
    }
    const migracijaView=(migracijaid,migracijatipsifra)=>{
        onViewDolazak(migracijaid,migracijatipsifra);
    }

    const showDolasci=()=>{
        return (
            <Box display={'flex'} flexDir={'column'} flex={1}>
                <TableContainer overflowY={'auto'} h={'75vh'} mb={'1rem'} className='noscroll'>
                    <Table variant={'unstyled'} size={tableSize}>
                        <Thead _hover={{cursor:'pointer'}} fontSize={tableSize}>
                            <Tr>
                                <Th w={'2%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                                <Th w={'14%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Knjiga</Th>
                                <Th w={'8%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Tip</Th>
                                <Th w={'4%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Država uvoz</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                                <Th w={'20%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Prijašnji posjednik</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>IJR</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Dokument</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Broj grla</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Unio</Th>
                                
                            </Tr>
                        </Thead>
                        <Tbody>
                        {/* onClick={(mid,tip)=>migracijaShow(item.migracija_id,item.migracija_tip_sifra)} bg:'grunt2.100',*/}
                        {dolasci.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                             return (
                                <Tr color={'grunt2'} key={item.migracija_id}  bg={'white'} fontWeight={'normal'} 
                                _hover={{bg:'gray.100'}} h='2rem' >
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                    <Menu>
                                        <MenuButton
                                            as={IconButton}
                                            aria-label='Options'
                                            icon={<HamburgerIcon />}
                                            variant={'outline'} size={'xs'}
                                            isDisabled={readonly}
                                        />
                                        <MenuList>
                                            
                                            <MenuItem icon={<ImStatsDots size={'14px'}/>} onClick={()=>onStat(item.migracija_id)}>
                                                Statistika
                                            </MenuItem>
                                            <MenuItem icon={<ViewIcon boxSize={'14px'}/>} onClick={()=>migracijaView(item.migracija_id,item.migracija_tip_sifra)}>
                                                Pregled
                                            </MenuItem>
                                            <MenuItem icon={<EditIcon boxSize={'14px'}/>} onClick={(mid,tip)=>migracijaEdit(item.migracija_id,item.migracija_tip_sifra)}>
                                                Uredi podatke
                                            </MenuItem>
                                            
                                        </MenuList>
                                    </Menu>
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>{item.knjiga}</Td>
                                    <Td fontSize={tableSize} textAlign={'center'}><Badge size={'xs'} fontWeight={'normal'} variant={'solid'} colorScheme={colorSchmemes[(item.migracija_tip.charCodeAt(0))%16]}>{item.migracija_tip}</Badge></Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                        {item.odldrzavacode!=="HR"?<Badge size={'xs'} fontWeight={'normal'} variant={'solid'} colorScheme={colorSchmemes[(item.odldrzavacode.charCodeAt(0))%16]}>{item.odldrzavacode}</Badge>:"--"}
                                        
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>{new Date(item.datum).toLocaleDateString('hr-HR')}</Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>{item.migracija_tip_id===11?"--":item.jibg!==''?`${item.odlposjednik} (${item.jibg})`:item.odlposjednik}</Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>{new Date(item.ijr).toLocaleDateString('hr-HR')}</Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>{item.dokument_broj}</Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>{readonly?"--":item.br_grla}</Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                        <Tooltip label={item.unio} fontSize={'xs'} placement={'auto'}>
                                            <Avatar color={'black'} size={'xs'} bg={'grunt2.100'} name={item.unio}/>
                                        </Tooltip>
                                    </Td>
                                </Tr>
                             )
                        })}
                        </Tbody>
                        </Table>
                </TableContainer>
              
        </Box>
        )
    }
    
    const getFooter=()=>{
        return (
            
            <Box flexDir={'row'} display={'flex'} h={'1.5rem'} alignItems={'center'} mb={'0.2rem'}>
                
                <Box w={'25%'}>
                    {showBrZapis()}
                </Box>
                <Box w={'50%'}>
                    <Center>
                    {ShowGruntPager()}
                    </Center>
                </Box>
                <Box w={'25%'}>
                    
                </Box>
                
            </Box>
            
        )
    }
    const showBrZapis=()=>{
        return (
          <Text fontSize={'xs'}>Prikazano zapisa: {dolasci.length}</Text>
        )
      }
  return (
    <Box display={'flex'} flexDir={'column'} flex={1} >
        {showDolasci()}
        {getFooter()}
    </Box>
  )
}
